const auctionStates = {
  active: 'active',
  awaitingAcceptance: 'awaiting_acceptance',
  counterAccepted: 'counter_accepted',
  counterDeclined: 'counter_declined',
  counterOriginalAccepted: 'counter_original_accepted',
  counterOriginalDeclined: 'counter_original_declined',
  counterSent: 'counter_sent',
  endedAccepted: 'ended_accepted',
  endedDeclined: 'ended_declined',
  endedKilled: 'ended_killed',
  endedNobid: 'ended_nobid',
  endedSellerTimeout: 'ended_seller_timeout',
  endedUnwound: 'ended_unwound',
  negotiation: 'negotiation',
  runList: 'run_list',
  preview: 'preview',
  staging: 'staging',
};

const acceptedStates = [
  auctionStates.counterAccepted,
  auctionStates.counterOriginalAccepted,
  auctionStates.endedAccepted,
];

const negotiationStates = [
  auctionStates.awaitingAcceptance,
  auctionStates.counterSent,
  auctionStates.negotiation,
];

const negotiationAcceptedStates = [
  auctionStates.counterAccepted,
  auctionStates.counterOriginalAccepted,
];

const negotiationUnsoldStates = [
  auctionStates.counterOriginalDeclined,
  auctionStates.endedDeclined,
];

const makeOfferStates = [
  auctionStates.counterOriginalDeclined,
  auctionStates.endedDeclined,
  auctionStates.endedNobid,
];

const endedStates = [
  auctionStates.awaitingAcceptance,
  auctionStates.counterAccepted,
  auctionStates.counterDeclined,
  auctionStates.counterOriginalAccepted,
  auctionStates.counterOriginalDeclined,
  auctionStates.counterSent,
  auctionStates.endedAccepted,
  auctionStates.endedDeclined,
  auctionStates.endedKilled,
  auctionStates.endedNobid,
  auctionStates.endedSellerTimeout,
  auctionStates.endedUnwound,
  auctionStates.negotiation,
];

const finalStates = [
  auctionStates.counterAccepted,
  auctionStates.counterOriginalAccepted,
  auctionStates.counterOriginalDeclined,
  auctionStates.endedAccepted,
  auctionStates.endedDeclined,
  auctionStates.endedKilled,
  auctionStates.endedNobid,
  auctionStates.endedSellerTimeout,
  auctionStates.endedUnwound,
];

const unsoldStates = [
  auctionStates.counterOriginalDeclined,
  auctionStates.endedDeclined,
  auctionStates.endedKilled,
  auctionStates.endedNobid,
  auctionStates.endedSellerTimeout,
  auctionStates.endedUnwound,
];

const endedNoParticipationStates = [
  auctionStates.endedNobid,
  auctionStates.endedKilled,
  auctionStates.endedUnwound,
];

const relaunchableStates = [
  auctionStates.counterOriginalDeclined,
  auctionStates.endedDeclined,
  auctionStates.endedNobid,
  auctionStates.endedKilled,
  auctionStates.endedUnwound,
];

// try exporting default first, then exporting the others separately.
export {
  /* eslint-disable-next-line */
  auctionStates as default,
  acceptedStates,
  negotiationStates,
  negotiationAcceptedStates,
  negotiationUnsoldStates,
  makeOfferStates,
  endedStates,
  endedNoParticipationStates,
  finalStates,
  unsoldStates,
  relaunchableStates,
};
